import React from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { CalendarSlot, Meeting } from "../../../types";

interface CancelMeetingConfirmationModalProps {
  open: boolean;
  meeting: CalendarSlot | null;
  onConfirm: () => void;
  onClose: () => void;
}

const CancelMeetingConfirmationModal: React.FC<
  CancelMeetingConfirmationModalProps
> = ({ open, meeting, onConfirm, onClose }) => {
  const formatMeetingDate = (date: Date) => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle component="div">
        <Typography variant="h3">Cancel Meeting</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body1">
            Are you sure you want to cancel the following meeting?
          </Typography>
          {meeting && (
            <Chip
              label={`${formatMeetingDate(meeting.startTime)}`}
            />
          )}
          <Typography variant="body1">
            <b>This action cannot be undone.</b>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" fullWidth>
          Keep Meeting
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" fullWidth>
          Cancel Meeting
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelMeetingConfirmationModal;
